import axios from "axios"
import baseURL from "../config/api"

export const post_Group = (data: any, token: string) => {
    return axios({
        url: `${baseURL}group`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_Group = (data: any, token: string) => {
    return axios({
        url: `${baseURL}group`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_Group = (primaryKey: string, token: string) => {
    return axios({
        url: `${baseURL}group`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const getGroupsBySearch = (search: string, page: number, size: number, token: string) => {
    const searchValue = search?.trim()?.toLowerCase();
    if (searchValue === "") {
        return getFetch(`group/GetGroupReportSortedByChurchNamePaging/${page},${size}`, token)
    } else {
        return getFetch(`group/GetGroupReporttSortedByChurchNameAndSearchWithChurchName?churchName=${searchValue}&page=${page}&size=${size}`, token)
    }
}

export const getGroups = (token: string) => {
    return getFetch("group", token)
}

export const getGroup = (primaryKey: string, token: string) => {
    return getFetch(`group/${primaryKey}`, token)
}

export const getGroupById = (primaryKey: string, token: string) => {
    return getFetch(`group/GetGroupById/${primaryKey}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params,
    }).then(response => response.data);
}

export const getGroupDetails = (encryptedGroupId: string) => {
    return getFetchWithoutToken(`group/details/${encryptedGroupId}`)
}

const getFetchWithoutToken = async (url: string, params = {}) => {
    return await axios({
        url: baseURL + url,
        method: "GET",
        params: params,
    }).then(response => response.data);
}